import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import {PropType, watch, onMounted, computed} from "vue";
import {TabsItem, VATabsOptions} from "./typings";
import {useTabsHandler} from "./hooks";


export default /*@__PURE__*/_defineComponent({
  __name: 'VATabs',
  props: {
  value: {
    type: [String, Number],
    required: true
  },
  options: {
    type: Object as PropType<VATabsOptions | Array<TabsItem>>,
    required: true
  }
},
  emits: ['on-change', 'update:value'],
  setup(__props, { emit: __emit }) {

const emit = __emit

// 静态数据初始化第一条数据点击事件
onMounted(()=>{
  if (props.options instanceof  Array){
    initChange(props.options[0].value)
  }
})

const props = __props
// 获取远程数据
const {data} = useTabsHandler(props.options as VATabsOptions)

const source = computed(()=>{
  return (props.options instanceof Array)?props.options:data.value
})

const onChange = (value: any) =>{
  emit('update:value', value)
  emit('on-change', value)
}

// 进来则渲染第一个按钮，并触发点击事件，初始化点击第一个按钮
const initChange = (value: any)=>{
  onChange(value)
}
// 获取远程数据后初始化第一个值
watch(()=>data.value,()=>{
  initChange(data.value[0].value)
}, {deep: true})

return (_ctx: any,_cache: any) => {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!

  return (_openBlock(), _createBlock(_component_a_tabs, {
    activeKey: __props.value,
    "tab-position": __props.options.position,
    type: __props.options.type,
    "tab-bar-gutter": __props.options.barGutter,
    size: __props.options.size,
    onChange: onChange
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(source.value, (item) => {
        return (_openBlock(), _createBlock(_component_a_tab_pane, {
          key: item.value,
          disabled: item.disabled
        }, {
          tab: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(item.label), 1)
          ]),
          default: _withCtx(() => [
            (item.slot)
              ? _renderSlot(_ctx.$slots, item.slot, { key: 0 })
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1032, ["disabled"]))
      }), 128))
    ]),
    _: 3
  }, 8, ["activeKey", "tab-position", "type", "tab-bar-gutter", "size"]))
}
}

})